export const referenceConstants = {
    LOAD_REQUEST: 'REFERENCE_LOAD_REQUEST',
    LOAD_SUCCESS: 'REFERENCE_LOAD_SUCCESS',
    LOAD_FAILURE: 'REFERENCE_LOAD_FAILURE',

    SEARCH_REQUEST: 'REFERENCE_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'REFERENCE_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'REFERENCE_SEARCH_FAILURE',

    SELECT_REQUEST: 'REFERENCE_SELECT_REQUEST',

    DETAILS_REQUEST: 'REFERENCE_DETAILS_REQUEST',
    DETAILS_SUCCESS: 'REFERENCE_DETAILS_SUCCESS',
    DETAILS_FAILURE: 'REFERENCE_DETAILS_FAILURE',
}
